var _defs, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivacyIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.2,
    height: 14,
    viewBox: "0 0 29.2 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-2,.cls-3{fill-rule:evenodd;}.cls-4,.cls-3{fill:#333;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "final---dec.11-2020"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_0208-our-toggle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Final-Copy-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m7,12.8h6.8l3.1-11.6H7c-3.2,0-5.8,2.6-5.8,5.8s2.6,5.8,5.8,5.8Z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "final---dec.11-2020-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_0208-our-toggle-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Final-Copy-2-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m7,12.8h6.8l3.1-11.6H7c-3.2,0-5.8,2.6-5.8,5.8s2.6,5.8,5.8,5.8Z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "final---dec.11-2020-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_0208-our-toggle-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Final-Copy-2-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m22.2,0H7C3.1,0,0,3.1,0,7s3.1,7,7,7h15.2c3.9,0,7-3.1,7-7S26,0,22.2,0ZM1.2,7C1.2,3.8,3.8,1.2,7,1.2h9.9l-3.1,11.6h-6.8c-3.2,0-5.8-2.6-5.8-5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x",
    className: "cls-4",
    d: "m24.2,4c.2.2.2.6,0,.8h0l-2.1,2.2,2.2,2.2c.2.2.2.6,0,.8s-.6.2-.8,0h0l-2.2-2.2-2.2,2.2c-.2.2-.6.2-.8,0-.2-.2-.2-.6,0-.8h0l2.1-2.2-2.2-2.2c-.2-.2-.2-.6,0-.8.2-.2.6-.2.8,0h0l2.2,2.2,2.2-2.2c.2-.2.6-.2.8,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y",
    className: "cls-1",
    d: "m12.3,4.1c.2.2.3.6.1.8h0l-4.2,4.9c-.1.1-.2.2-.3.2-.2.1-.5.1-.7-.1h0l-2.2-2.2c-.2-.2-.2-.6,0-.8.2-.2.6-.2.8,0h0l1.8,1.7,3.8-4.5c.2-.2.6-.2.9,0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyIcon);
export default __webpack_public_path__ + "static/media/privacy-icon.038d5a13a89ffb5f7b1e4d8bc599706f.svg";
export { ForwardRef as ReactComponent };